import styled from 'styled-components'

const Boton = styled.button`
  padding: 1rem;
  border: 2px solid white;
  background-color: rgba(255, 255, 255, 0.1);
  margin-bottom: 1rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  &:focus {
    outline: 0;
  }
`

export { Boton }
